import type { KissType } from "/vue/types/user_list";

// A Kiss only disables its own button, a French Kiss or a Hot Note disables all three: a premium kiss
// also counts as a Kiss for the cooldown.
export function disabledButtons(type: KissType | null | undefined): KissType[] {
  if (!type) return [];

  return type === "kiss" ? ["kiss"] : ["kiss", "french_kiss", "hot_note"];
}
